dhara

<img src="../../../assets/moviebundles.png" style="width: 100%; cursor: pointer;" (click)="onImageClick()"/>